module.exports = "pegasus/assets/blocks/column-10-theme2.png";